import React from 'react';
import { Section } from '../../../a11y/headings/tagWrappers';
import Heading from '../../../a11y/headings/Heading';
import { styleFromWidthHeight, getDeviationType } from '../../_helpers';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { DeviationTypes } from '../../../types/deviation';
import s from './MiniText.scss';
// This is not a DS card, just a small placeholder for places that
// are too tiny to show text anyway, ie. the user avatar tooltip
// It's based on antfart-sized lit dumbo
export var MiniText = function (_a) {
    var width = _a.width, height = _a.height, responsive = _a.responsive, deviation = _a.deviation, title = _a.deviation.title, ariaHidden = _a["aria-hidden"];
    var deviationType = getDeviationType(deviation);
    return (React.createElement(Section, { className: s['root'], style: styleFromWidthHeight({ width: width, height: height }, responsive), "aria-hidden": ariaHidden },
        deviationType === DeviationTypes.LITERATURE && (React.createElement(LiteratureCoverLetter, { title: title, isBigEnough: false })),
        React.createElement(Heading, { className: s['title'] }, title)));
};
MiniText.displayName = 'MiniText';
export default MiniText;
//# sourceMappingURL=MiniText.js.map